// extracted by mini-css-extract-plugin
export default {"title":"Learnings_title__78VtT","fadeIn":"Learnings_fadeIn__9Cuef","searchContainer":"Learnings_searchContainer__OHukX"};